import {ReactNode} from "react";
import WrapCreateFolderDialogContext from "./folder/create/WrapCreateFolderDialogContext";
import WrapQRCodeStyleDialogContext from "./qr-code/style/WrapQRCodeStyleDialogContext";
import WrapQRCodeFolderDialogContext from "./qr-code/folder/WrapQRCodeFolderDialogContext";

type WrapDialogsContextsProps = {
    /**
     * Children to be wrapped.
     * @author Kacper Faber
     * @since 0.1.9
     */
    children: ReactNode;
};

/**
 * To wrap all dialog contexts (from components/dialogs/**).
 * @author Kacper Faber
 * @since 0.1.9
 */
function WrapDialogsContexts(props: WrapDialogsContextsProps) {
    return (
        <WrapCreateFolderDialogContext>
            <WrapQRCodeFolderDialogContext>
                <WrapQRCodeStyleDialogContext>
                    {props.children}
                </WrapQRCodeStyleDialogContext>
            </WrapQRCodeFolderDialogContext>
        </WrapCreateFolderDialogContext>
    );
}

export default WrapDialogsContexts;